import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Image from 'components/image';
import imageResizer from 'js/image-resizer';
import useBreakpoints from 'hooks/use-breakpoints';

const ArticlePageHero = ({ heading, smallHeading, image, imageMobile }) => {
  const { isMobile } = useBreakpoints(true);
  const [imageHeight, setImageHeight] = useState(0);
  const [imageWidth, setImageWidth] = useState(0);

  useEffect(() => {
    if (typeof isMobile === 'undefined') {
      return;
    }

    if (isMobile) {
      setImageHeight(null);
    } else {
      setImageHeight(imageResizer.calcImageHeight(700, 100));
    }
  }, [isMobile]);

  useEffect(() => {
    setImageWidth(
      imageResizer.calcImageWidth(Math.min(1800, window.screen.width))
    );
  }, []);

  const currentImage = isMobile ? imageMobile || image : image;

  return (
    <div className="article-page-hero">
      <div className="article-page-hero__content">
        <div className="article-page-hero__container">
          <div className="article-page-hero__text-info">
            <div
              role="presentation"
              className="article-page-hero__background"
            ></div>
            {heading && (
              <h1 className="article-page-hero__heading">{heading}</h1>
            )}
            {smallHeading && (
              <span className="article-page-hero__small-heading">
                {smallHeading}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="article-page-hero__image-holder">
        {currentImage &&
        (isMobile || (!isMobile && imageHeight && imageWidth)) ? (
          <Image
            {...currentImage}
            key={isMobile}
            fluid={!isMobile}
            {...(!isMobile && {
              width: imageWidth,
              height: imageHeight,
            })}
            className="article-page-hero__image image_size_article-page-hero"
          />
        ) : null}
      </div>
    </div>
  );
};

ArticlePageHero.propTypes = {
  heading: PropTypes.string,
  smallHeading: PropTypes.string,
  image: PropTypes.exact(Image.propTypes),
  imageMobile: PropTypes.exact(Image.propTypes),
};

export default ArticlePageHero;
